import React from 'react';
import { Link } from 'react-router-dom';
import BlogLayout from '@/components/BlogLayout';
import SEO from '@/components/SEO';
import ServiceCTA from '@/components/services/ServiceCTA';
import ServiceFAQ from '@/components/services/ServiceFAQ';
import { serviceContent } from '@/components/services/serviceContent';

export default function ServiceDetail({ serviceKey }) {
  const service = serviceContent[serviceKey];
  const url = `https://fortcollinsgaragedoor.repair${service.path}`;
  const structuredData = { '@context': 'https://schema.org', '@graph': [
    { '@type': 'Service', '@id': `${url}#service`, name: service.title, description: service.description, url,
      serviceType: service.label, provider: { '@id': 'https://fortcollinsgaragedoor.repair/#business' }, areaServed: { '@type': 'City', name: 'Fort Collins, Colorado' } },
    { '@type': 'FAQPage', '@id': `${url}#faq`, mainEntity: service.faqs.map(({ q, a }) => ({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a } })) },
    { '@type': 'BreadcrumbList', itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://fortcollinsgaragedoor.repair/' },
      { '@type': 'ListItem', position: 2, name: service.label, item: url }
    ] }
  ] };
  return (
    <BlogLayout>
      <SEO title={`${service.title} | M Garage Door Repair`} description={service.description} path={service.path} structuredData={structuredData} />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-20 text-foreground">
        <nav aria-label="Breadcrumb" className="text-sm text-muted-foreground"><Link to="/" className="underline">Home</Link> <span aria-hidden="true">/</span> <span aria-current="page">{service.label}</span></nav>
        <h1 className="mt-6 text-3xl sm:text-5xl font-heading font-bold tracking-tight">{service.title}</h1>
        <p className="mt-6 text-lg text-muted-foreground leading-relaxed">{service.intro}</p>
        <ServiceCTA />
        {service.sections.map(({ id, heading, text }) => <section key={heading} id={id} className="mt-9 scroll-mt-24"><h2 className="text-2xl font-bold">{heading}</h2><p className="mt-3 text-muted-foreground leading-relaxed">{text}</p></section>)}
        <ServiceFAQ faqs={service.faqs} />
        <section className="mt-10 border-t border-border pt-8">
          <h2 className="text-xl font-bold">Related services and advice</h2>
          <ul className="mt-4 space-y-3">{Object.entries(serviceContent).filter(([key]) => key !== serviceKey).map(([key, item]) => <li key={key}><Link className="underline underline-offset-4" to={item.path}>{item.label}</Link></li>)}<li><Link className="underline underline-offset-4" to="/garage-door-guide">Garage door repair and safety guide</Link></li></ul>
        </section>
      </article>
    </BlogLayout>
  );
}